import { invokeApig } from '../../../libs/awsLib';

export const getCommentMessages = async (entityId, encounterId) => {
  const data = await invokeApig({
    path: `/entity/${entityId}/encounter/${encounterId}/messages`,
  });
  return data;
};

export const saveCommentMessage = async (entityId, encounterId, message) => {
  return await invokeApig({
    path: `/entity/${entityId}/encounter/${encounterId}/new-message`,
    method: 'POST',
    body: {
      message: message,
    },
  });
};

export const updateCommentMessage = async (entityId, encounterId, message) => {
  return await invokeApig({
    path: `/entity/${entityId}/encounter/${encounterId}/update-message`,
    method: 'PUT',
    body: {
      message: message,
    },
  });
};

export const getAtMentionUsers = async (
  searchTerm,
  facilityId,
  organizationId,
  xsolisYN,
  teamIds
) => {
  return await invokeApig({
    path: `/mention/users`,
    method: 'POST',
    body: {
      searchTerm,
      facilityId,
      organizationId,
      xsolisYN,
      teamIds,
    },
  });
};
